export default function TransferIcon({ type = 'right' }) {
  return (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="23" height="23" rx="11.5" fill="#FAB23D" />
      {type === 'right' ? (
        <path
          d="M6.396 11.5023C6.03701 11.5023 5.746 11.7934 5.746 12.1523C5.746 12.5113 6.03701 12.8023 6.396 12.8023V11.5023ZM17.0889 12.612C17.3428 12.3581 17.3428 11.9466 17.0889 11.6927L12.9524 7.55615C12.6985 7.30231 12.287 7.30231 12.0331 7.55615C11.7793 7.80999 11.7793 8.22155 12.0331 8.47539L15.7101 12.1523L12.0331 15.8293C11.7793 16.0831 11.7793 16.4947 12.0331 16.7485C12.287 17.0024 12.6985 17.0024 12.9524 16.7485L17.0889 12.612ZM6.396 12.8023H16.6293V11.5023H6.396V12.8023Z"
          fill="black"
        />
      ) : (
        <path
          d="M17.104 12.65C17.463 12.65 17.754 12.359 17.754 12C17.754 11.641 17.463 11.35 17.104 11.35L17.104 12.65ZM6.41106 11.5404C6.15722 11.7942 6.15722 12.2058 6.41106 12.4596L10.5476 16.5962C10.8015 16.85 11.213 16.85 11.4669 16.5962C11.7207 16.3424 11.7207 15.9308 11.4669 15.677L7.78992 12L11.4669 8.32304C11.7207 8.0692 11.7207 7.65765 11.4669 7.4038C11.213 7.14996 10.8015 7.14996 10.5476 7.4038L6.41106 11.5404ZM17.104 11.35L6.87068 11.35L6.87068 12.65L17.104 12.65L17.104 11.35Z"
          fill="black"
        />
      )}
    </svg>
  )
}
